import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SummaryButton, SummaryItem } from '../../models';
import { FormService, MenuService, ModalService, RouterService } from '../../services';
import { BaseComponent } from '../base/base.component';
import { DiscardChangesModalComponent } from '../modals';

@Component({
  selector: 'app-summary-top',
  templateUrl: './summary-top.component.html',
  styleUrl: './summary-top.component.scss',
})
export class SummaryTopComponent extends BaseComponent implements OnInit {
  @Input() header: string;
  @Input() name: string;
  @Input() model$: Observable<any>;
  @Input() additionalButtons: SummaryButton[];
  @Input() summaryItems: (model: any) => SummaryItem[];
  @Input() fullWidth = false;
  @Input() mobile = false;
  @Input() showBack = true;
  @Input() showCopy = false;
  @Input() showSave = true;
  @Input() saveButtonText = $localize`Save`;
  @Input() copyButtonText = $localize`Copy`;
  @Input() enableCopyButton = true;
  @Output() copyModel = new EventEmitter<any>();

  readonly createHeader = $localize`Create`;
  readonly editHeader = $localize`Edit`;

  private modalLevel: number;
  private saved = false;

  constructor(
    public menuService: MenuService,
    private formService: FormService,
    private routerService: RouterService,
    private modalService: ModalService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.modalLevel = this.modalService.modalLevel;
    this.formService.saveComplete.pipe(takeUntil(this.destroy$)).subscribe(() => (this.saved = true));
  }

  get isModal() {
    return this.modalLevel > 0;
  }

  get showSaveButton() {
    return this.showSave && !this.menuService.isReadOnly;
  }

  showAdditionalButtons(model: any) {
    return !!this.additionalButtons?.length && !this.menuService.isReadOnly && !this.isNewModel(model);
  }

  showCopyButton(model: any) {
    return this.showCopy && !this.menuService.isReadOnly && !this.isNewModel(model);
  }

  isNewModel(model: any): boolean {
    return this.formService.isNewModel(model);
  }

  back() {
    if (this.formService.anyFormChanges(this.modalLevel)) {
      this.modalService.openMedium<DiscardChangesModalComponent>(DiscardChangesModalComponent).modal.result.then(
        (discardChanges: boolean) => {
          if (discardChanges) {
            this.formService.resetForms(this.modalService.modalLevel);
            this.navigate();
          }
        },
        () => {},
      );
    } else {
      this.navigate();
    }
  }

  save() {
    this.formService.save.next(this.modalLevel);
  }

  private navigate() {
    if (this.isModal) {
      if (this.saved) {
        this.modalService.close();
      } else {
        this.modalService.dismiss();
      }
    } else if (this.mobile) {
      this.routerService.top();
    } else {
      this.routerService.back(this.route);
    }
  }
}
